var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGardenDashboardHarvestSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GardenDashboardHarvestSVG 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "basketOutline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M87.3428 46C92.4596 46.4115 92.4744 51.9793 92.4744 54.676V58.7672V62.8586V66.9498V71.0412C92.4744 73.7379 91.9279 76.3068 90.9396 78.6436C89.9514 80.9803 88.5211 83.0846 86.7539 84.8518C84.9867 86.6189 82.8824 88.0492 80.5457 89.0375C78.209 90.0258 75.6398 90.5725 72.9432 90.5725H61.4713H49.9992H38.5271H27.0551C24.3584 90.5725 21.7893 90.0258 19.4526 89.0375C17.1159 88.0492 15.0116 86.6189 13.2444 84.8518C11.4772 83.0846 10.047 80.9803 9.05869 78.6436C8.07035 76.3068 7.52383 73.7379 7.52383 71.0412V66.9498V62.8586V58.7672V54.676C7.52383 51.9793 7.27307 46.4373 12.6982 45.5004C16.3979 44.8615 78.7098 45.3059 87.3428 46Z",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "basketHandle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6982 45.5004C12.6982 40.2473 13.7432 35.3244 15.6323 30.8951C17.5215 26.4656 20.2547 22.5297 23.6311 19.2502C27.0074 15.9709 31.027 13.3481 35.4889 11.5452C39.9506 9.74232 44.8547 8.75928 50 8.75928C55.1453 8.75928 60.052 9.77355 64.5176 11.6233C68.9832 13.473 73.008 16.1582 76.3895 19.5C79.7709 22.8418 82.5094 26.8402 84.4023 31.3166C86.2953 35.7928 87.3428 40.7469 87.3428 46C87.3428 46 68.6816 45.3166 50.0205 45.1916C31.3594 45.0668 12.6982 45.5004 12.6982 45.5004Z",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "basketMiddle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.0737 84.3537L42.1832 45.3824",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.1314 89.668L56.5334 46",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M38.3873 89.6631L71.2742 46.2158",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M52.484 90.3242L85.55 45.8498",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M68.3209 89.6432L91.8244 58.0752",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.68547 70.8992L26.6898 45.6084",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardenDashboardHarvestSvg);
export default __webpack_public_path__ + "static/media/GardenDashboardHarvestSVG.44e2103661bd3b565e983f80127674b6.svg";
export { ForwardRef as ReactComponent };